<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی ذی نفعان چارچوب میچل  </h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <hr class="mb-3">
            <center v-if="!status">
              {{ error }}
            </center>
            <div v-if="status" style="height: auto; margin-bottom: 10vw;">
              <table class="table table-striped" >
                <tr>
                  <td class="bg-info" style="width: 10vw;">ذینفعان اولویت بالا</td>
                  <td  colspan="3">
                  <div class="d-flex flex-column">
                    <span>قطعی</span>
                    <span>مشروعیت، قدرت و فوریت</span>
                  </div>
                  </td>
                  <td>
                    <div v-if="silent.length" class="d-flex justify-content-start w-100 align-items-end flex-wrap">
                      <p v-for="(item,index) in silent">{{index+1}}-{{item.title}}</p>
                    </div>
                    <center v-else>
                      موردی یافت نشد
                    </center>
                  </td>
                </tr>
                <tr>
                  <td class="bg-info2">ذینفعان اولویت متوسط</td>
                  <td style="width: 10vw;">
                  <div class="d-flex flex-column">
                    <span>مسلط</span>
                    <span>مشروعیت و قدرت</span>
                  </div>
                  </td>
                  <td style="width: 10vw;">
                    <div class="d-flex flex-column">
                      <span>وابسته</span>
                      <span>مشروعیت و فوریت</span>
                    </div>
                      </td>
                  <td style="width: 10vw;">
                    <div class="d-flex flex-column">
                      <span>خطرناک</span>
                      <span>قدرت و فوریت</span>
                    </div>
                  </td>
                  <td>
                    <div v-if="dominates.length" class="d-flex justify-content-start w-100 align-items-end flex-wrap">
                    <p v-for="(item,index) in dominates">{{index+1}}-{{item.title}}</p>
                    </div>
                    <center v-else>
                      موردی یافت نشد
                    </center>
                  </td>
                </tr>
                <tr>
                  <td class="bg-secondary">ذینفعان اولویت پایین</td>
                  <td>
                    <div class="d-flex flex-column">
                      <span>ساکت</span>
                      <span>قدرت</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex flex-column">
                      <span>محتاط</span>
                      <span>مشروعیت</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex flex-column">
                      <span>متقاضی</span>
                      <span>فوریت</span>
                    </div>
                  </td>
                  <td>
                    <div v-if="certain.length" class="d-flex justify-content-start w-100 align-items-end flex-wrap">
                    <p v-for="(item,index) in certain">{{index+1}}-{{item.title}}</p>

                    </div>
                    <center v-else>
                      موردی یافت نشد
                    </center>
                  </td>
                </tr>
              </table>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import BeneficiaryRow from "@/components/beneficiary/BeneficiaryRowMitchell.vue";
import {useToast} from "vue-toastification";
import router from "@/router";

const toast = useToast();

export default {
  name: "beneficiary_id_order_by",
  components: {Sidebar, Splash, BeneficiaryRow},
  data() {
    return {
      averages: [],
      items: [],
      status: false,
      error: 'دوره ای برای ارزیابی ذی نفعان تعریف نشده است.',
      all_beneficiary: [],
      updated_beneficiaries: [],
      silent: [],
      dominates: [],
      certain: [],
      cautious: [],
      dangerous: [],
      dependents: [],
      applicants: [],
      items_table: [],
      flow_x: '',
      type_name: '',
      status_flow: false,
    };
  },
  methods: {
    resetModal(){
      this.status_flow=false
      this.flow_x = 0

    },

    showModal(type) {
      this.flow_x = -22
      this.status_flow = true

      let item = parseInt(type)
      if (item === 1) {
        this.items_table = this.silent
        this.type_name = 'ساکت'
        this.type_name+='(قدرت)'
      } else if (item === 2) {
        this.items_table = this.dominates
        this.type_name = 'مسلط'
        this.type_name+='(قدرت،مشروعیت)'


      } else if (item === 3) {
        this.items_table = this.certain
        this.type_name = 'قطعی'
        this.type_name+='(قدرت،مشروعیت،فوریت)'

      } else if (item === 4) {
        this.items_table = this.cautious
        this.type_name = 'خطرناک'
        this.type_name+='(قدرت،فوریت)'

      } else if (item === 5) {
        this.items_table = this.dangerous
        this.type_name = 'محتاط'
        this.type_name+='(مشروعیت)'

      } else if (item === 6) {
        this.items_table = this.dependents
        this.type_name = 'وابسته'
        this.type_name+='(مشروعیت،فوریت)'

      } else if (item === 7) {
        this.items_table = this.applicants
        this.type_name = 'متقاضی'
        this.type_name+='(فوریت)'

      }
    },
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryPeriod/show`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.status = false;
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            if (response.item) {
              this.status = true;
              this.all_beneficiaryMethod();
            }

          })
          .catch();
    },
    all_beneficiaryMethod() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/all_for_mitchell_aggregated`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            this.all_beneficiary = [...response.all];
            this.averages = response.averages;
            this.silent = [...response.silent,...response.cautious,...response.applicants]

            this.dominates = [...response.dominates]

            this.certain = [...response.certain,...response.dangerous,...response.dependents]



          })
          .catch();
    },
    updateBeneficiary(updatedItem) {
      const index = this.updated_beneficiaries.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        this.updated_beneficiaries[index] = updatedItem;
      } else {
        this.updated_beneficiaries.push(updatedItem);
      }
    },
    saveAll() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({items: this.updated_beneficiaries}),
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary_mitchell/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error);
              return;
            }
            toast.success('داده‌ها با موفقیت ذخیره شدند.');
          })
          .catch(error => {
            toast.error('خطایی رخ داده است.');
          });
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/pishkhan')
      }


      return;
    }
  },
  mounted() {
    this.checkIsMother();
    this.all();
  }
};
</script>

<style scoped lang="scss">
.translate2{
  transition: all ease 2s;
}.translate{
  transition: all ease 500ms;
}
.span {
  font-size: 1vw;
  font-weight: 900;
  cursor: pointer;
  transition: all ease 500ms;

  &:hover {
    border-bottom: 0.1vw solid #000;
  }
}

.span_1 {
  left: 25vw;
}

.span_2 {
  left: 35vw;
  top: 5vw;
}

.span_3 {
  left: 35vw;
  top: 10vw;
}

.span_4 {
  left: 28vw;
  top: 15vw;
}

.span_5 {
  left: 42vw;
  top: 4vw;
}

.span_6 {
  left: 40vw;
  top: 14vw;
}

.span_7 {
  left: 34vw;
  top: 20vw;
}

.span_8 {
  left: 22vw;
  top: 0;
  position: relative;

  &:after {
    position: absolute;
    top: 2vw;
    right: -1vw;
    content: '';
    width: 2vw;
    height: 0.1vw;
    background-color: #222;
    transform: rotate(45deg);
  }
}

.span_9 {
  left: 47vw;
  top: 0;
  position: relative;

  &:after {
    position: absolute;
    top: 2.5vw;
    right: 2vw;
    content: '';
    width: 2vw;
    height: 0.1vw;
    background-color: #222;
    transform: rotate(-45deg);
  }
}

.span_10 {
  left: 44vw;
  bottom: -8vw;
  position: relative;

  &:after {
    position: absolute;
    top: 0.1vw;
    right: 3vw;
    content: '';
    width: 2vw;
    height: 0.1vw;
    background-color: #222;
    transform: rotate(45deg);
  }
}

.circle {
  background-color: rgba(#5e67fc, 0.2);
  width: 18vw;
  height: 18vw;
  border: 0.1vw solid #222;

  &:nth-child(1) {
    transform: translateX(-14vw);
  }

  &:nth-child(2) {
    transform: translateY(8vw);
  }

  &:nth-child(3) {
    transform: translateX(14vw);
  }
}

.row {
  padding: .5vw;
}

h3 {
  font-size: 1.5vw !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}
</style>
